import { SVGProps } from 'react';

const FlipHorizontal2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 20v2m0-8v2m0-8v2m0-8v2M3 7l5 5-5 5zm18 0-5 5 5 5z"
    />
  </svg>
);
export default FlipHorizontal2;
